import Vue from 'vue';
import Vuex, { StoreOptions } from 'vuex';

import { getters } from '@/store/getters';
import { mutations } from '@/store/mutations';
import { actions } from '@/store/actions';
import { NotificationTypeEnum } from '@/enums/notification-type.enum';
import { RootState } from './types';
import { DriverStatusEnum, UserRoleEnum } from '@/services/api-clients';

Vue.use(Vuex);

const store: StoreOptions<RootState> = {
  state: {
    loading: false,
    snackbar: {
      type: NotificationTypeEnum.Info,
      content: [''],
    },
    visitedHints: {
      vehicleLog: false,
    },
    confirm: {
      title: '',
      content: '',
      result: null,
      cookieSkipKey: undefined,
      isOpen: false,
    },
    reasonPrompt: {
      statusId: DriverStatusEnum.Problem,
      reason: '',
      result: null,
      isOpen: false,
    },
    onceDialog: {
      title: '',
      content: '',
      isOpen: false,
    },
    initialized: false,
    userInfo: {
      id: '',
      displayName: '',
      organisationsNames: [],
      isMasterOrganisation: false,
      applicationAccountsAccess: false,
      canMarkPaymentAsExecuted: false,
      haveAccessToAuditArea: false,
      massDeleteSettlements: false,
      sendSettlementEmailsToDrivers: false,
      canDeleteDrivers: false,
      canChangeDriverDisableRequestStatus: false,
      canExportSettlements: false,
      canImportSettlements: false,
      canModifyPetrolGross: false,
      canModifySettlementApplication: false,
      canModifyRavapiBonus: false,
      canApproveSettlements: false,
      canMoveSettlementBackToWaiting: false,
      canMassSetVehiclesCommission: false,
      canDeletePayoff: false,
      canCancelPayoff: false,
      canExportRequestForPayment: false,
      role: UserRoleEnum.Specialist,
      statisticBundleId: 0,
      haveAccessToReportArea: false,
      canApproveCollidingSettlements: false,
      canMassAdjustSettlementCommissions: false,
      canHoldOffSettlementPayoff: false,
      canExportEquipmentReturnRequest: false,
      canExportToPdfProofOfIncome: false,
      canRemoveDriverContactForm: false,
      canExportPaymentsSummaryForTax: false,
      canChangeStateExcludeFromExportSettlement: false,
      canCreateInvoice: false,
      canManualEditDriverSubject: false,
      isExcludedFromDriverDayOffReminderMailingList: false,
      canChangeVehicleIsIncludedInDayOff: false,
      canChangeVehicleCommissions: false,
      canChangeVehicleDiscountedCommissions: false,
      isExcludedFromVehicleCommissionsReminder: false,
      canManageVehicleDocuments: false,
      canImportPayoffs: false,
      canAssignDigitalPromissoryNoteInReceivingVehicle: false,
      haveAccessToDigitalDocumentsManageArea: false,
      canConfirmDriverDocumentsWithoutUploadingFile: false,
      canManageBonusCampaigns: false,
      canRemoveBlockingWithdrawDriverStatusTags: false,
      skipMissingVehicleRentDigitalDocumentsPopupReminder: false,
      canViewMissingDriversDigitalDocuments: false,
      canChangeStudentValidationStatus: false,
      canEditDriverContractStartDate: false,
      haveAccessToMailArea: false,
      canAddOrRemoveDriverDayoff: false,
      canManageMailRules: false,
      haveAccessToOnlinePayments: false,
      canSendOnlinePaymentRequestToDebtors: false,
      canRemovePayUPayoffs: false,
      haveAccessToInvitePrograms: false,
      canPublishInviteProgram: false,
      canDeleteInviteProgramDraft: false,
      canDeleteInviteProgram: false,
      canRemoveReferralPayoffs: false,
      canRemoveOnlinePayments: false,
      canSettleDriverViaOnlinePayments: false,
      canEditPayoffOnlinePayment: false,
      haveAccessToReferral: false,
      canDeleteReferral: false,
      canEditReferral: false,
      canAddOnlinePaymentInvoice: false,
      canExportDriversToCsv: false,
      haveFullAccessToEditMassCampaigns: false,
      canApproveMassCampaigns: false,
      haveAccessToMassCampaigns: false,
      canSendDriverDataToFlovi: false,
      haveAccessToExportDebtorsForPenaltySummary: false,
      haveAccessToExportsArea: false,
      canExportSettlementsReport: false,
      canExportVehiclePaidRent: false,
      canExportWorkLog: false,
      canExportTakenCashFromSettlements: false,
      canExportUserWithdrawSummary: false,
      canMassDeletePayoffs: false,
      canMassRemoveDriversFromSII: false,
      canMassReportDriversToSII: false,
      canManageVehicleCashback: false,
      canExportPayoffs: false,
      canSendInvoiceToKSeF: false,
      canChangeMobileApplicationDriverFileVisibility: false,
      canClaimSupportTicket: false,
      canTakeOverSupportTicket: false,
      canCloseSupportTicket: false,
      canDeleteSupportTicket: false,
      canMassDeleteSupportTickets: false,
      haveAccessToAiKnowledgeBase: false,
      canManageAiKnowledgeBase: false,
      canMassCancelSiiPayoffs: false,
      canForceRavapiPaymentsTitle: false,
      canMassAddSiiPayoffs: false,
    },
    articleGroups: [],
    ksefEnabled: false,
    openSupportTicketsCount: 0,
    messageNotifications: [],
    notificationSoundEnabled: true,
    supportChatPopupRequest: null,
  },
  modules: {},
  actions,
  mutations,
  getters,
};

export default new Vuex.Store<RootState>(store);
